/* tslint:disable */
/* eslint-disable */
/**
 * Location check service API
 * Service to centralise business area handling for multiple depending services.
 *
*/

import { exists, mapValues } from '../runtime';
import type { PositionRto } from './PositionRto';
import {
    PositionRtoFromJSON,
    PositionRtoFromJSONTyped,
    PositionRtoToJSON,
} from './PositionRto';

/**
 * 
 * @export
 * @interface LcRequestRto
 */
export interface LcRequestRto {
    /**
     * 
     * @type {string}
     * @memberof LcRequestRto
     */
    crossBorderOpt?: string;
    /**
     * 
     * @type {PositionRto}
     * @memberof LcRequestRto
     */
    position: PositionRto;
    /**
     * 
     * @type {number}
     * @memberof LcRequestRto
     */
    locationId: number;
}

/**
 * Check if a given object implements the LcRequestRto interface.
 */
export function instanceOfLcRequestRto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "locationId" in value;

    return isInstance;
}

export function LcRequestRtoFromJSON(json: any): LcRequestRto {
    return LcRequestRtoFromJSONTyped(json, false);
}

export function LcRequestRtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LcRequestRto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'crossBorderOpt': !exists(json, 'crossBorderOpt') ? undefined : json['crossBorderOpt'],
        'position': PositionRtoFromJSON(json['position']),
        'locationId': json['locationId'],
    };
}

export function LcRequestRtoToJSON(value?: LcRequestRto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'crossBorderOpt': value.crossBorderOpt,
        'position': PositionRtoToJSON(value.position),
        'locationId': value.locationId,
    };
}

